import dayjs from 'dayjs'

import { IDates } from '../useTimezoneConverter'
import { TravelTypeEnum } from '../../../../lib/graphql'
import { pushToGTM } from '../../../../utils/pushToGTM'

type Range<T> = [T, T]
type ValuePiece = Date | null
type ReactCalendarValue = ValuePiece | Range<ValuePiece>

type HandleOnCalendarSelectDateProps = {
  startDate: IDates['startDate']
  value: ReactCalendarValue
  closeModal?: () => void
  setDate: (props: IDates) => void
  travelType: TravelTypeEnum | null
  shouldDisplayHourPickers: boolean | undefined
}
export const handleOnCalendarSelectDate = ({
  startDate,
  value,
  closeModal,
  setDate,
  travelType,
  shouldDisplayHourPickers,
}: HandleOnCalendarSelectDateProps) => {
  const isMultiDays = Array.isArray(value)

  if (isMultiDays) {
    const [selectedStart, selectedEnd] = value

    if (selectedStart) {
      pushToGTM({
        event: 'customEvent',
        category: 'onChange',
        action: 'changeStartDate',
        label: 'aller',
      })
    }

    if (selectedEnd) {
      /**
       * Allow to reset the date if we click click again on the same date
       * - Except for StudyDay that can be either a single day or multiple days
       */
      if (
        dayjs(selectedEnd).isSame(selectedStart, 'day') &&
        travelType === TravelTypeEnum.NIGHTLY_TRIP
      ) {
        return setDate({ endDate: undefined, startDate: undefined })
      }

      closeModal?.()

      pushToGTM({
        event: 'customEvent',
        category: 'onChange-Date',
        action: 'changeReturnDate',
        label: 'retour',
      })
    }

    setDate({
      startDate: selectedStart ?? undefined,
      endDate: selectedEnd ?? undefined,
    })
  } else {
    const selectedDate = value

    if (selectedDate) {
      /**
       * Allow to reset the date if we click click again on the same date
       */
      if (dayjs(selectedDate).isSame(startDate, 'day')) {
        return setDate({ endDate: undefined, startDate: undefined })
      }

      setDate({ startDate: value, endDate: value })

      if (!shouldDisplayHourPickers) {
        closeModal?.()
      }

      if (travelType === TravelTypeEnum.CORPORATE_EVENING_EVENT) {
        return pushToGTM({
          event: 'customEvent',
          category: 'onChange',
          action: 'setCorpoateEveningEvent',
          label: `CorporateEveningEvent date set`,
        })
      }
    }
  }
}
